import { createPerimeter } from 'vue-kindergarten';

export default createPerimeter({
  purpose: 'base',

  can: {
    watch() {
      return this.isLogined()
    }
  },

  isLogined() {
    return this.child && this.child.logined;
  },
})